// TEAMS Website - CarnegieHallSection Component
// Featured event showcase for Carnegie Hall performance

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../hooks/useScrollReveal.js';
import SectionHeader from '../ui/SectionHeader.jsx';
import { events } from '../../data/events.js';
import '../../styles/main.scss';

const CarnegieHallSection = () => {
  const { t, i18n } = useTranslation();
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });
  const lang = i18n.language;

  // Get the Carnegie Hall event
  const carnegieEvent = events.find(event => event.slug === 'carnegie-hall-2026');

  if (!carnegieEvent) return null;

  const title = carnegieEvent.title[lang] || carnegieEvent.title.en;
  const description = carnegieEvent.description[lang] || carnegieEvent.description.en;
  const fullDescription = carnegieEvent.fullDescription[lang] || carnegieEvent.fullDescription.en;

  return (
    <section className="carnegie-hall-section" ref={ref}>
      <div className="carnegie-hall-section__container">
        <div className={`carnegie-hall-section__content ${isVisible ? 'carnegie-hall-section__content--visible' : ''}`}>
          {/* Section Header */}
          <SectionHeader
            title={title}
            subtitle={`${carnegieEvent.location.name}, ${carnegieEvent.location.city}, ${carnegieEvent.location.country}`}
            alignment="center"
            size="large"
          />

          {/* Event Content */}
          <div className="carnegie-hall-section__event">
            {/* Image */}
            <div className="carnegie-hall-section__image">
              <img 
                src={carnegieEvent.image} 
                alt={title}
                className="carnegie-hall-section__event-image"
              />
            </div>

            {/* Details */}
            <div className="carnegie-hall-section__details">
              
              <div className="carnegie-hall-section__description">
                <p className="carnegie-hall-section__short-desc">{description}</p>
                <p className="carnegie-hall-section__full-desc">{fullDescription}</p>
              </div>

              {/* Performers */}
              <div className="carnegie-hall-section__performers">
                <h4>{t('eventDetail.performers')}</h4>
                <ul>
                  {carnegieEvent.performers.map((performer, index) => (
                    <li key={index}>{performer}</li>
                  ))}
                </ul>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarnegieHallSection;
